<!--用户管理-->
<template>
    <div class="userManager">
        <div class="module-name">
            <div class="module-title">用户管理</div>
        </div>
        <div class="oper">
            <a class="btn btn-default" href="createUsersTemplate.xlsx" download>批量创建用户模板下载</a>&nbsp;&nbsp;&nbsp;
            <span class="btn btn-default fileinput-button">
                <span>批量添加用户</span>
                <input
                    class=""
                    name="file"
                    type="file"
                    accept="xls/xlsx"
                    @change="updateFile"
                >
            </span>
        </div>
        <v-table
            :columns="columns"
            :tableData="tableData"
            v-model="selectItems"
            :isShowLoading="isShowLoading"
            :isShowNoData="isShowNoData"
        ></v-table>
        <pagination :current="page.current" :total="page.total" @on-change="changePage"></pagination>
        <publicModal
            ref="userModal"
            name="userModal"
            width="50%"
            :title="'用户详情'"
            @beforeOpen="beforeOpen"
            @confirm="confirm"
            @closed="closed"
        >
            <form class="form-horizontal">
                <div class="form-group" :class="{'has-error':errors.has('nickName')}">
                    <label for class="col-lg-3 control-label">昵称</label>
                    <div class="col-lg-8">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="请输入昵称"
                            v-model="currUserinfo.nickname"
                            v-validate="'required'"
                            name="nickName"
                        >
                        <p
                            class="invalidate-input-error"
                            v-if="errors.has('nickName')"
                            v-text="errors.first('nickName')"
                        ></p>
                    </div>
                </div>
                <div class="form-group">
                    <label for class="col-lg-3 control-label">真实姓名</label>
                    <div class="col-lg-8">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="请输入姓名"
                            v-model="currUserinfo.truename"
                        >
                    </div>
                </div>
                <div class="form-group">
                    <label for class="col-lg-3 control-label">性别</label>
                    <div class="col-lg-8">
                        <label class="radio-inline">
                            <input
                                type="radio"
                                @click="currUserinfo.sex=0"
                                :checked="currUserinfo.sex==0"
                            > 男
                        </label>
                        <label class="radio-inline">
                            <input
                                type="radio"
                                @click="currUserinfo.sex=1"
                                :checked="currUserinfo.sex==1"
                            > 女
                        </label>
                    </div>
                </div>
                <div class="form-group">
                    <label for class="col-lg-3 control-label">邮箱</label>
                    <div class="col-lg-8">
                        <input
                            type="email"
                            class="form-control"
                            placeholder="请输入邮箱"
                            v-model="currUserinfo.email"
                        >
                    </div>
                </div>
                <div class="form-group">
                    <label for class="col-lg-3 control-label">地址</label>
                    <div class="col-lg-8">
                        <input
                            type="email"
                            class="form-control"
                            placeholder="请输入地址"
                            v-model="currUserinfo.address"
                        >
                    </div>
                </div>
            </form>
        </publicModal>
    </div>
</template>

<script>
export default {
    name: "userManager",
    data() {
        return {
            files: [],
            tableData: [],
            selectItems: [],
            isShowLoading: false,
            isShowNoData: false,
            currUserinfo: {}, //修改用户的对象 当前修改用户的对象
            page: {
                current: 1,
                total: 0,
                pagesize: 10
            },
            columns: [
                {
                    type: "number",
                    title: "序号",
                    width: 50
                },
                {
                    field: "nickname",
                    title: "昵称",
                    width: 80
                },
                {
                    field: "truename",
                    title: "真实姓名",
                    width: 80
                },
                {
                    field: "sex",
                    title: "性别",
                    width: 100,
                    dataFormatter(row) {
                        return row.sex == 0 ? "男" : "女";
                    }
                },
                {
                    field: "address",
                    title: "地址",
                    width: 100
                },
                {
                    field: "createTimeStr",
                    title: "创建时间",
                    width: 100
                },
                {
                    field: "oper",
                    title: "管理",
                    width: 150,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "button",
                                {
                                    class: "btn btn-primary btn-sm",
                                    domProps: {
                                        innerText: "修改"
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.userModal.show(
                                                params.row.id
                                            ); //打开咨询详情的弹窗
                                        }
                                    }
                                },
                                ""
                            ),
                            h(
                                "button",
                                {
                                    class: "btn btn-danger btn-sm",
                                    domProps: {
                                        innerText: "删除"
                                    },
                                    on: {
                                        click: row => {
                                            this.deleteUser(params.row.id);
                                        }
                                    }
                                },
                                ""
                            )
                        ]);
                    }
                }
            ]
        };
    },
    mounted() {
        this.requestData();
    },
    methods: {
        requestData() {
            this.$http
                .post("/user/queryUserList", {
                    pageNo: this.page.current,
                    pageSize: this.page.pagesize
                })
                .then(res => {
                    this.tableData = res.result;
                    this.isShowLoading = false;
                    if (res.result.length == 0) {
                        this.isShowNoData = true;
                    } else {
                        this.isShowNoData = false;
                    }
                    this.page.current = res.thisPageNumber;
                    this.page.total = res.totalCount;
                    this.page.pagesize = res.pageSize;
                });
        },
        changePage(pageNum) {
            this.page.current = pageNum;
            this.requestData();
        },
        deleteUser(userid) {
            this.$confirm.init({
                title: "删除用户",
                content: "确认删除该用户吗？",
                onOk: () => {
                    this.$http
                        .post("/user/deleteUser", {
                            userId: userid
                        })
                        .then(res => {
                            this.$alert.init({
                                type: "success",
                                content: res.content
                            });
                            this.requestData();
                        });
                }
            });
        },
        updateFile(e) {
            let file = e.target.files[0];
            let param = new FormData(); //创建form对象
            param.append("file", file); //通过append向form对象添加数据
            this.$http.post("user/importUsers", param).then(res => {
                this.$alert.init({
                    type: "success",
                    content: res.content
                });
                this.requestData();
            });
        },
        //根据用户id获取用户的详情
        getUserinfoById(uid) {
            this.$http
                .post("user/findUserById", {
                    userId: uid
                })
                .then(res => {
                    this.currUserinfo = res;
                });
        },
        beforeOpen(uid) {
            this.getUserinfoById(uid);
        },
        //更新用户
        confirm() {
            // nickname	昵称	否
            // email	电子邮箱	否
            // truename	真实姓名	否
            // sex	性别	否（0：男 1：女）
            // address
            this.$http
                .post("user/updateUser", {
                    id: this.currUserinfo.id,
                    nickname: this.currUserinfo.nickname,
                    email: this.currUserinfo.email,
                    truename: this.currUserinfo.truename,
                    sex: this.currUserinfo.sex,
                    address: this.currUserinfo.address
                })
                .then(res => {
                    this.$alert.init({
                        type: "success",
                        content: res.content
                    });
                    this.requestData();
                    this.currUserinfo = res;
                    this.$refs.userModal.hide(); //打开咨询详情的弹窗
                });
        },
        closed() {
            this.currUserinfo = {};
        }
    }
};
</script>

<style>
.user-manager {
}
</style>